<template>
	<v-card flat class="elevation-0 tag-form pl-1">
		<v-form
			class="d-flex align-center"
			ref="form"
			v-model="valid"
			lazy-validation
			@submit.prevent="validateAndSubmit"
		>
			<v-text-field
				class="pr-10 pt-0"
				placeholder="Please enter tag name..."
				:value="fields.name"
				v-model="fields.name"
				:error-messages="field_errors.name"
				:rules="rules.name"
				required
			></v-text-field>
			<v-btn small class="tag-form__submit" type="submit" :loading="loading"> Add new </v-btn>
		</v-form>
	</v-card>
</template>

<script>
import { mapActions } from 'vuex'
import Form from '@/mixins/Form'
import { ruleNotEmpty } from '@/utils/rules'

export default {
	name: 'TagForm',
	mixins: [Form],
	fields: {
		name: '',
	},
	methods: {
		...mapActions('tag', ['addTag']),
		submitForm() {
			const data = new FormData()
			data.append('name', this.fields.name)
			return this.addTag(data)
		},
	},
	computed: {
		rules() {
			return {
				tag: [(v) => ruleNotEmpty(v) || 'Tag name must contain at least 1 symbol.'],
			}
		},
	},
}
</script>

<style lang="scss">
.tag-form {
	&__submit {
		border-radius: 24.5px;
		background-color: #e5e5e5 !important;
		color: rgba(77, 83, 110, 0.5) !important;
		font-family: Montserrat;
		font-style: normal;
		font-weight: 900;
		font-size: 15px;
		line-height: 16px;
		text-align: center;

		&:hover {
			color: #fff !important;
			background-color: #db7842 !important;
			opacity: 1;
		}
	}
}
</style>
